const Data = (function () {

    const date = new Date();
    let data, patchData, patchValues;

    const dataURL = '/data/keywordsGlobalUpdated20180212-20.json?' + date.getDay() + date.getHours();
    const patchDataURL = '/data/ogb-keyword-whitelist.json?' + date.getDay() + date.getHours();
    const _error = console.error;

    function init () {
        return Promise.all([
            fetchData(),
            fetchPatchData(),
        ])
        /*
        .then(function () {
            const gTop20 = Object.keys(data.keywords)
                .sort((a,b) => {
                    return data.keywords[b].length - data.keywords[a].length
                })
            console.log(gTop20)
        })
        */
    }

    function fetchData () {
        return $.getJSON(dataURL)
            .then(res => {
                data = res;
                return data;
            })
            .catch(e => _error(e));
    }

    function fetchPatchData () {
        return $.getJSON(patchDataURL)
            .then(res => {
                patchData = res;
                return data;
            })
            .catch(e => _error(e));
    }

    function getData () {
        return data;
    }

    function getLocations () {
        return Object.keys(data.locations).sort().map(location => {
            return { name: location, type: 'locations' }
        });
    }

    function getCategories () {
        return Object.keys(data.categories).map(category => {
            return { name: category, type: 'categories' }
        });
    }

    function getBrags (key = 'global') {
        const keys = key.split('/');
        let result;
        if (keys.length === 1) {
            result = data[keys[0]];
        } else {
            result = data[keys[0]][keys[1]];
        }

        /*
            Here `keys[0]` can be any of:
            - global
            - locations
            - categories
        */
        switch (keys[0]) {
            case 'global':
            case 'locations': {
                // 1. Filter the list in patchData to include only the current location or 'global'
                let ogbSelectionForLocation = patchData
                    .filter(row => {
                        if (keys.length === 1) {
                            // Global
                            return row['City'].toLowerCase() === keys[0].toLowerCase()
                        } else {
                            // Locations/CityName
                            return row['City'].toLowerCase() === keys[1].toLowerCase()
                        }
                    })
                    .map(row => row['Selected UNMODIFIED words'])
                // 2. Filter the top20 to top10 by matching OGB's selection
                let ogbResult = result.filter(keyword => ogbSelectionForLocation.indexOf(keyword) >= 0);
                // 3. Due to misspellings in the original search terms, some matches may be lost lost (e.g. "catherdal" became "cathedral") so let's fill them in with whatever comes next
                if (ogbResult.length < 10) {
                    ogbResult = ogbResult.concat(result.slice(ogbResult.length -1, ogbResult.length))
                }
                // 4. Last sanity check in case there's a missing city, then just use the data straight from the top20
                result = (ogbResult.length) ? ogbResult : result;
                result = result.slice(0,10);
                break;
            }
            default:
                result = result.slice(0,10);
        }
        return result.map(keyword => ({name: keyword, key: key}));
    }

    function getTaxonomyName (key = 'global') {
        const keys = key.split('/');
        if (keys.length === 1) return keys[0];
        return keys[1];
    }

    function getTaxonomy (key = 'global') {
        const keys = key.split('/');
        return keys[0];
    }

    function getLocationCoords(location) {
        if (!data.locationsCoords.hasOwnProperty(location)) return false;
        return data.locationsCoords[location];
    }

    /**
    Transform JSON data for Globe.js
    */
    function makeGlobeData (groupName, subgroupName) {
        // Make "groupName", "subgroupName" into "groupName/subgroupName"
        const key = [groupName,subgroupName].filter(x => !!x).join('/');
        // Get the keywords
        let keywords = getBrags(key).map(x => x.name);
        const keywordsData = [];
        keywords.forEach((keyword) => {
            let keywordData = data.keywords[keyword] || [];
            if (keywordData.length) {
                // Map cities to coords
                const coordsMag = [];
                for (let index = 0; index < keywordData.length; index+=2) {
                    const coords = getLocationCoords(keywordData[index]);
                    coordsMag.push(coords[0],coords[1],keywordData[index+1]);
                }
                keywordsData.push([keyword, coordsMag]);
            }
        });

        // Normalise magnitude values
        let minM = 10000;
        let maxM = 0;
        for (let i = 0; i < keywordsData.length; i += 1) {
            const keywordData = keywordsData[i][1];
            for (let j = 2; j < keywordData.length; j += 3) {
                const mag = keywordData[j];
                minM = Math.min(minM, mag);
                maxM = Math.max(maxM, mag);
            }
        }

        for (let i = 0; i < keywordsData.length; i += 1) {
            for (let j = 2; j < keywordsData[i][1].length; j += 3) {
                let val = keywordsData[i][1][j];
                const perc = (val - minM) / (maxM - minM);
                keywordsData[i][1][j] = perc;
                // Optionally log-length lines
                // const exp = 2;
                // val = (perc * ((10 ** exp) - 1)) + 1;
                // keywordsData[i][1][j] = Math.log10(val) / exp; // log scale
            }
        }

        // Scatter longitudes
        for (let i = 0; i < keywordsData.length; i += 1) {
            for (let j = 1; j < keywordsData[i][1].length; j += 3) {
                keywordsData[i][1][j] += (i - 5) * 0.3;
            }
        }

        return keywordsData;
    }

    return {
        init,
        getLocations,
        getCategories,
        getBrags,
        makeGlobeData,
        getData,
        getTaxonomyName,
        getTaxonomy,
        getLocationCoords,
    };
})()
